module.exports = __webpack_public_path__ + "static/media/logo-collapsed.f5a6fa47.png";